import {
  Injectable,
  Injector,
  Inject,
  Optional,
  ComponentRef,
  ComponentFactoryResolver,
  ApplicationRef,
  Type,
} from '@angular/core';

import { COMPONENT_REGISTRY, SHELL_DEFAULT_OPTIONS } from '../providers';
import { ComponentMap, ShellOptions } from '../interfaces';
import { WindowShellComponent } from '../components/window-shell/window-shell.component';
import { noProviderError, formRegistryError } from '../../shared/exceptions';
import { WindowManager } from './window-manager.service';

@Injectable()

export class WindowFactory {

  constructor(
    private windowMng: WindowManager,
    private appRef: ApplicationRef,
    private injector: Injector,
    private factoryResolver: ComponentFactoryResolver,
    @Inject(SHELL_DEFAULT_OPTIONS) private defaultOptions: ShellOptions,
    @Optional() @Inject(COMPONENT_REGISTRY) private registry: ComponentMap[]) {

    if (!this.registry) {
      noProviderError('COMPONENT_REGISTRY');
    }
  }


  public open(name: string, options: ShellOptions = {}) {
    const shellFactory = this.factoryResolver.resolveComponentFactory(WindowShellComponent);
    const shell = shellFactory.create(this.injector);
    const nativeNode = shell.instance.hostView.nativeElement;
    this.initShell(shell, name, options);

    this.appRef.attachView(shell.hostView);
    document.body.appendChild(nativeNode);

    return {
      close() {
        shell.destroy();
      },

      afterClose(callback) {
        shell.onDestroy(() => callback());
      }
    };
  }

  public closeLast(): void {
    if (this.windowMng.quantity) {
      this.windowMng.activeWindows.pop().destroy();
    }
  }

  public closeAll(): void {
    this.windowMng.activeWindows.forEach(window => window.destroy());
    this.windowMng.activeWindows.length = 0;
  }


  private getComponent(name: string): Type<any> | never {
    const formMap = this.registry.find(map => map.name === name);
    if (!formMap) {
      formRegistryError(name);
    }

    return formMap.component;
  }

  private initShell(shellRef: ComponentRef<WindowShellComponent>, name: string, options: ShellOptions): void {
    shellRef.instance.name = name;
    shellRef.instance.embeddedView = this.getComponent(name);
    shellRef.instance.options = {...this.defaultOptions, ...options};
    shellRef.instance.ref = shellRef;
    shellRef.instance.focus();
    this.windowMng.activeWindows.push(shellRef);
  }

}
